/* Native Fragmentlinks bleiben ohne JavaScript nutzbar. Ein Listener-Satz für alle Instanzen. */
(() => {
  if (window.customBtAnleitungenLoaded) return;
  window.customBtAnleitungenLoaded = true;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const timers = new WeakMap();
  function highlight(target, moveFocus = false) {
    if (!target) return;
    target.scrollIntoView({ behavior: reducedMotion.matches ? 'instant' : 'smooth', block: 'start' });
    if (moveFocus) target.focus({ preventScroll: true });
    target.classList.add('custom-bt-anleitungen__highlight');
    clearTimeout(timers.get(target));
    timers.set(target, setTimeout(() => target.classList.remove('custom-bt-anleitungen__highlight'), 1600));
  }
  function hashTarget() {
    let id;
    try { id = decodeURIComponent(location.hash.slice(1)); } catch { return null; }
    if (!id) return null;
    const exact = document.getElementById(id);
    if (exact?.matches('[data-bt-anleitungen], [data-bt-document]')) return exact;
    return [...document.querySelectorAll('[data-bt-anchor]')].find(el => el.dataset.btAnchor === id) || null;
  }
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search || !url.hash) return;
    let target;
    try { target = document.getElementById(decodeURIComponent(url.hash.slice(1))); } catch { return; }
    if (!target?.matches('[data-bt-anleitungen], [data-bt-document]')) return;
    event.preventDefault();
    history.pushState(null, '', url.hash);
    highlight(target, true);
  });
  window.addEventListener('hashchange', () => highlight(hashTarget(), true));
  function checkEditorAnchors() {
    if (!window.Shopify?.designMode) return;
    document.querySelectorAll('[data-bt-anleitungen]').forEach(section => {
      section.querySelectorAll('[data-bt-anchor-warning]').forEach(note => note.remove());
      const keys = [...section.querySelectorAll('[data-bt-document]')].map(el => el.dataset.btDocument);
      const duplicates = keys.filter((key, i) => keys.indexOf(key) !== i);
      if (!duplicates.length) return;
      const note = document.createElement('p');
      note.dataset.btAnchorWarning = '';
      note.className = 'custom-bt-anleitungen__editor-note';
      note.textContent = `Bitte eindeutige Dokumentkennungen verwenden: ${[...new Set(duplicates)].join(', ')}`;
      section.append(note);
    });
  }
  document.addEventListener('shopify:section:load', checkEditorAnchors);
  document.addEventListener('shopify:section:reorder', checkEditorAnchors);
  document.addEventListener('shopify:block:select', event => {
    if (!event.target.closest('[data-bt-anleitungen]')) return;
    highlight(event.target.closest('[data-bt-document], .custom-bt-anleitungen__video') || event.target);
  });
  document.addEventListener('shopify:section:select', event => highlight(event.target.querySelector('[data-bt-anleitungen]')));
  checkEditorAnchors();
  if (location.hash) requestAnimationFrame(() => highlight(hashTarget()));
})();
